import { getCategoryTree } from "@serophin/nottldr-shared";
import { PillPicker } from "./PillPicker";

export type CategoryFilterProps = {
  selectedCategory: string;
  selectedSubcategory: string;
  onCategoryChange: (category: string) => void;
  onSubcategoryChange: (subcategory: string) => void;
};

const namesOf = (entries: [string, { name: string }][]): Record<string, string> => Object.fromEntries(entries.map(([id, { name }]) => [id, name]));

const categoryNames = (): Record<string, string> => ({
  all: "All categories",
  ...namesOf(Object.entries(getCategoryTree())),
});

const subcategoryNames = (category: string): Record<string, string> => ({
  all: "All",
  ...namesOf(Object.entries(getCategoryTree()[category]?.subcategories ?? {})),
});

export const CategoryFilter = ({ selectedCategory, selectedSubcategory, onCategoryChange, onSubcategoryChange }: CategoryFilterProps) => (
  <>
    <div class="py-2">
      <PillPicker id="category" value={selectedCategory} onChange={onCategoryChange} values={categoryNames()} />
    </div>
    {selectedCategory !== "all" && (
      <div class="pb-2">
        <PillPicker id="subcategory" value={selectedSubcategory} onChange={onSubcategoryChange} values={subcategoryNames(selectedCategory)} small />
      </div>
    )}
  </>
);
